import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import './PartnerManager.css';
import useTaskDetail from '../../hooks/useTaskDetail';
import { TaskStepper } from './components';
import { DynamoDBItemExtended, DynamoDBItemWithDraft } from './types';

interface RouteParams {
    routeKey: string;
    taskId: string;
}

interface GeneratedInfo {
    supplierInfo: {
        supplierName: string;
        supplierId: string;
    };
}

const TaskDetail: React.FC = () => {
    const history = useHistory();
    const { path } = useRouteMatch();
    const { routeKey, taskId } = useParams<RouteParams>();
    const { task, loading, error } = useTaskDetail(routeKey);
    const [generatedInformation, setGeneratedInformation] = React.useState<GeneratedInfo>({
        supplierInfo: {
            supplierName: '',
            supplierId: '',        
        },
    });

    console.log('Task object', task);
    if (loading) {
        return (
            <div className="partner-manager-container">
                <Card className="task-queue-surface">
                    <div className="task-queue-shell">
                        <div className="task-detail-header">
                            <IconButton onClick={() => history.push('/ediSelfServicePortal/taskQueue')}>
                                <ArrowBackIcon />
                            </IconButton>
                            <h1 className="task-queue-title">Task Detail</h1>
                        </div>
                        <div className="task-card task-card-empty">
                            <p className="task-empty-state">Loading task details...</p>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    if (error) {
        return (
            <div className="partner-manager-container">
                <Card className="task-queue-surface">
                    <div className="task-queue-shell">
                        <div className="task-detail-header">
                            <IconButton onClick={() => history.push('/ediSelfServicePortal/taskQueue')}>
                                <ArrowBackIcon />
                            </IconButton>
                            <h1 className="task-queue-title">Task Detail</h1>
                        </div>
                        <div className="task-card task-card-empty">
                            <p className="task-empty-state">Error loading task: {error.message}</p>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    if (!task) {
        return (
            <div className="partner-manager-container">
                <Card className="task-queue-surface">
                    <div className="task-queue-shell">
                        <div className="task-detail-header">
                            <IconButton
                                onClick={() => history.push('/ediSelfServicePortal/taskQueue')}
                                className="task-detail-back"
                            >
                                <ArrowBackIcon />
                            </IconButton>
                            <h1 className="task-queue-title">Task Detail</h1>
                        </div>
                        <div className="task-card task-card-empty">
                            <p className="task-empty-state">Task not found for the selected route.</p>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    return (
        <div className="partner-manager-container">
            <TaskStepper task={task} />
        {/* <GeneratedInformation task={task as DynamoDBItemWithDraft} /> */}
        </div>
    );
};

export default TaskDetail;